// extracted by css-extract-rspack-plugin
export default {"issueNumberText":"IssuePicker-module__issueNumberText__pmfhv","issueItem":"IssuePicker-module__issueItem__zncbD"};